/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/Addresses/Content/Address/Edit/Content/Fields/Zip",
  isInvalid,
  onChange
  
}) {
let editAddressPostalAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'edit_address',
path: 'postal_address.zip',
})
let editAddressPostalAddressZipIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_address',
path: 'postal_address.zip',
validate: fromValidate.zip,
required: true,
})
let editAddressPostalAddressZipChangeData = fromData.useDataChange({ viewPath,
context: 'edit_address',
path: 'postal_address.zip',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_address.postal_address.zip"
 validate="/Data/validate.js zip"
 required={true}
 invalid={!editAddressPostalAddressZipIsValidData}
 value={editAddressPostalAddressZipValueData}
 onChange={editAddressPostalAddressZipChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP Code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}